module.exports = __webpack_public_path__ + "static/media/search-tickets.85c42c89.svg";